import { ADD_COMMENT, SET_COMMENTS, SET_COMMENTS_LOADING, SET_ITEM_ID_COMMENTS } from "./constants";

export const addCommentActions = (payload) => ({ type: ADD_COMMENT, payload });
export const setCommentsAction = (payload) => ({ type: SET_COMMENTS, payload });
export const setCommentsLoadingAction = (payload) => ({ type: SET_COMMENTS_LOADING, payload });
export const setItemIdCommentsAction = (payload) => ({ type: SET_ITEM_ID_COMMENTS, payload });